import React from 'react';
import { useState } from 'react';
import { useAppContext } from 'components/Context/AppContext';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import ButtonAdd from 'components/Global/ButtonAdd';
import { ReactComponent as EventMasterIcon } from 'icons/event-master-filled-icon.svg';
import { PaginationTable, Table, TableWrapper } from 'components/Global';
import LoadingSpinner from 'components/Global/LoadingSpinner';
import { deleteEventById, getAllEvents } from 'features/holiday-charge/actions';
import { trackEvent } from 'utils/analytics';
import EmptyState from 'components/Global/EmptyState';
import { getAllRentalLocation } from 'features/rental-location/actions';
import { format, parseISO } from 'date-fns';
import { resetSelectedEvent } from 'features/holiday-charge/eventSlice';

const EventMasterComponent = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const column = [
    { header: 'No.', value: 'no' },
    { header: 'Nama Hari Libur', value: 'name' },
    { header: 'Lokasi', value: 'event_locations' },
    { header: 'Tanggal', value: 'holiday_period' },
  ];

  const { setShowConfirmation, setShowSpinner, showToast } = useAppContext();

  const { isLoading, data: eventsData } = useSelector((state) => state.events);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllEvents({ page: currentPage, limit: 10 }));
  }, [dispatch, currentPage]);

  useEffect(() => {
    dispatch(getAllRentalLocation());
  }, [dispatch]);

  const handleDelete = (e) => {
    const eventId = e.target.parentElement.parentElement.dataset['key'];
    setShowConfirmation({
      message: 'Apakah anda yakin ingin menghapus item ini?',
      show: true,
      onClick: async () => {
        try {
          setShowSpinner(true);
          trackEvent('event_deleted', { event_id: eventId, source: 'event_master_list' });
          await dispatch(deleteEventById(eventId)).unwrap();
          showToast({ type: 'success', message: 'Berhasil Hapus Item' });
          setCurrentPage(1);
          dispatch(getAllEvents({ page: 1, limit: 10 }));
        } catch (error) {
          showToast({ type: 'error', message: 'Gagal Hapus Item' });
        } finally {
          setShowSpinner(false);
        }
      },
    });
  };

  const handleEdit = (e) => {
    const eventId = e.target.parentElement.parentElement.dataset['key'];
    dispatch(resetSelectedEvent());
    navigate(`/event-master/edit?id=${eventId}`);
  };

  const parseHolidayPeriod = (startDate, endDate) => {
    if (startDate === endDate) {
      return format(parseISO(startDate), 'dd MMMM yyyy');
    } else {
      return format(parseISO(startDate), 'dd MMMM - ').concat(format(parseISO(endDate), 'dd MMMM yyyy'));
    }
  };

  const handleAdd = () => {
    dispatch(resetSelectedEvent());
    navigate('/event-master/add');
  };

  const mappedData = eventsData?.data?.map((item) => ({
    id: item.id,
    name: item.name,
    event_locations: item.location?.name,
    holiday_period: parseHolidayPeriod(item.date, item.end_date),
  }));

  return (
    <div className="event-master">
      <ButtonAdd onClick={handleAdd} label="Tambah" />

      <TableWrapper title="Event Master Data" icon={<EventMasterIcon fill="#009EF7" width="25px" height="25px" />}>
        {isLoading ? (
          <LoadingSpinner />
        ) : eventsData?.data?.length ? (
          <>
            <Table
              column={column}
              data={mappedData}
              actionBtn
              onDel={handleDelete}
              onEdit={handleEdit}
              currentPage={currentPage}
            />
            <PaginationTable
              currentPage={currentPage}
              onPageChange={(newPage) => setCurrentPage(newPage)}
              totalCount={eventsData.pagination?.total}
            />
          </>
        ) : (
          <EmptyState />
        )}
      </TableWrapper>
    </div>
  );
};

export default EventMasterComponent;
